module.exports = __webpack_public_path__ + "assets/images/cockpit/hover/btn_closedc_off-hover_ru.png";